module.exports = __webpack_public_path__ + "img/strip_c.164697e4.jpg";